import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import style from "./date.module.css";
import { useRef } from "react";

const DateInput = ({ name, value, label, onChange, className }) => {
  const formatDateForInput = (date) => {
  if (!date) return "";
  if (typeof date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
    return date; 
  }

  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};


  const dateRef = useRef(null);

  const openDate = () => {
    if (dateRef.current) {
      dateRef.current.showPicker?.(); 
      dateRef.current.focus(); 
    }
  };

  return (
    <div className={`${className || ""} ${style.date}`}>
      {label && <label htmlFor={name}>{label}</label>}

      <div className={style.dateShow}>
        <span>{formatDateForInput(value)}</span>
        <span onClick={openDate} style={{ cursor: "pointer" }}>
          <FontAwesomeIcon icon={faCalendar} />
        </span>
      </div>

      <input
        type="date"
        id={name}
        name={name}
        value={formatDateForInput(value)}
        onChange={onChange}
        ref={dateRef}
        className={style.hiddenDateInput}
      />
    </div>
  );
};

export default DateInput;
